module.exports = __webpack_public_path__ + "static/media/servo_360_img.db4870dd.jpg";